export const NEWBUILDING_ADFOX_SITE_JK_DESKTOP = 'newbuilding_adfox_site_jk_desktop';

export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_jk_desktop';
